import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import IconButton from '@mui/material/IconButton';
import { useCallback } from 'react';
import { createGetAccountInfoOutbound } from '../../api/outbound/commonOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
export const GoToAccountModalHeaderButton = ({ onClose }) => {
    const socketSend = useSocketSend();
    const onClickAccount = useCallback(() => {
        onClose();
        socketSend(createGetAccountInfoOutbound());
    }, [onClose, socketSend]);
    return (_jsx(IconButton, { title: 'Go To Account', onClick: onClickAccount, size: 'large', children: _jsx(ManageAccountsRoundedIcon, {}) }));
};
